import React from "react";

const Forbidden403: React.FC = () => {

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 px-6">
      <div className="bg-white p-10 rounded-2xl shadow-lg max-w-md text-center">
        <h1 className="text-6xl font-bold text-yellow-500">403</h1>
        <p className="text-xl font-semibold mt-4 text-gray-800">
          Accès interdit
        </p>
        <p className="text-gray-500 mt-2">
          Cette action est réservée aux utilisateurs habilités, tels que les
          agents chargés de la saisie des plaintes ou les points focaux.
          Veuillez contacter l'administrateur du système si vous pensez qu'il
          s'agit d'une erreur.
        </p>
        <p className="mt-6 px-6 py-3 bg-yellow-500 text-white font-medium rounded-xl transition duration-300">
          Contacter le support
        </p>
      </div>
    </div>
  );
};

export default Forbidden403;
